// © Microsoft Corporation. All rights reserved.
import { __awaiter } from "tslib";
import { perfMarker, WebWorkerMessageId } from "../wwCommon";
import { experienceConfigMap } from "../wwResolver";
/** Default OCID for some OneService requests */
export const defaultOneServiceOcid = "Peregrine";
export var OneServiceResponseSchema;
(function (OneServiceResponseSchema) {
    OneServiceResponseSchema["CardView"] = "cardview";
    OneServiceResponseSchema["FlatView"] = "flatview";
})(OneServiceResponseSchema || (OneServiceResponseSchema = {}));
/**
 * Reformats the given guid without dashes to a guid string with dashes.
 * @param {string} guid - The guid without dashes.
 * @returns The reformatted GUI with dashes.
 */
export function tryReformatGuid(guid) {
    if (guid && guid.length === 32) {
        // use a regex to extract the specific substrings to reformat the guid
        const matches = guid.match(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/i);
        if (matches) {
            // join all the captured groups from 1-5 to format the final guid string
            guid = matches.slice(1).join("-");
        }
    }
    return guid;
}
/**
 * Sets the search param if value is present.
 * NOTE: this function will not set the search param if value is undefined, null, false, empty strings or 0.
 * @param urlSearchParamsHelper URLSearchParamsHelper object
 * @param name the name of the search param
 * @param value the value of the search param
 */
export function trySetSearchParam(urlSearchParamsHelper, name, value) {
    if (!value) {
        return;
    }
    urlSearchParamsHelper.set(name, value);
}
/** Adds start perf marker name for message id */
export function addStartPerfMarker(messageId) {
    const markerPrefix = messageId === WebWorkerMessageId.MyFeed ? "MyFeed" : messageId;
    perfMarker(`${markerPrefix}FetchStart`);
}
/** Adds end perf marker name for message id */
export function addEndPerfMarker(messageId) {
    const markerPrefix = messageId === WebWorkerMessageId.MyFeed ? "MyFeed" : messageId;
    perfMarker(`${markerPrefix}FetchEnd`);
}
/** Subscribes to the given config and returns a promise that resolves when the config is ready */
export function subscribeToExperienceConfig(experienceType) {
    return __awaiter(this, void 0, void 0, function* () {
        let experienceConfigResolver;
        const experienceConfigReadyPromise = new Promise((resolve) => { experienceConfigResolver = resolve; });
        const experienceConfigSubscription = experienceConfigMap.subscribe(experienceType, () => {
            experienceConfigSubscription.unsubscribe();
            experienceConfigResolver();
        });
        return experienceConfigReadyPromise;
    });
}
//# sourceMappingURL=Common.js.map